export enum ApprovalRequestStatus {
  Pending,
  Approved,
  Declined,
}
